import axios from "axios";
import { baseUrl3 } from "../Config/Config";

axios.defaults.headers.post["Content-Type"] = "application/json";

export async function invokeApi3({
  path,
  method = "GET",
  headers = {},
  queryParams = {},
  postData = {},
}) {
  const reqObj = {
    method,
    url: baseUrl3 + path,
    headers,
  };

  reqObj.params = queryParams;

  if (method === "POST") {
    reqObj.data = postData;
  }
  if (method === "PATCH") {
    reqObj.data = postData;
  }
  if (method === "PUT") {
    reqObj.data = postData;
  }
  if (method === "DELETE") {
    reqObj.data = postData;
  }

  let results;


  try {
    results = await axios(reqObj);

    return results;
  } catch (error) {
        if ( error?.response?.status === 401 ) {
      localStorage.clear();
      // window.location.reload();
    }
    if (error.response) {
      return error.response.data;
    } else if (error.request) {
      // The request was made but no response was received (network issues, timeout, etc.)
      return { message: "No response received from server." };
    } else {
      return { message: "An unknown error occurred." };
    }
  }
}
